import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoader } from "./loader";

import * as endpoints from "../networkUtility/endpoints";
import { getLocalStorage } from "../LocalStorage/GetLocalStorage";
import * as localStorageActiontype from "../LocalStorage/ActionTypes";
import { toggleNotificationVisibility } from "./networkNotification";
import { NotificationType } from "../Utility/InterFacesAndEnum";
import { handle401Status } from "../Utility/Utility";

interface CoinObj {
  coinId: number;
  coinCode: string;
  coinTitle: string;
  coinPrice: number;
  coinDescription: string;
  coinImageUrls: [];
  coinThumbnailImageUrl: string;
}

interface CoinInitialStateProp {
  coins: [] | CoinObj[];
  purchaseList: any;
  singleCoin: any;
  isNavigate: boolean;
}

const coinInitialState: CoinInitialStateProp = {
  coins: [],
  purchaseList: [],
  singleCoin: {},
  isNavigate: false,
};

interface SetCoinProps {
  result: CoinObj[] | [];
}

interface SetCoinProps {
  result: CoinObj[] | [];
}
interface SetSingleCoinProps {
  result: any;
}

interface SetNavProp {
  result: boolean;
}

export const getCoins = createAsyncThunk(
  "get coins",
  async (payload, { dispatch }) => {
    dispatch(
      toggleLoader({
        isLoading: true,
      })
    );
    await fetch(endpoints.getCoinList, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        dispatch(
          toggleLoader({
            isLoading: false,
          })
        );
        return response.json();
      })
      .then((data) => {
        // console.log("coin list",data)

        if (data.statusCode === 200) {
          dispatch(setSingleCoin({ result: {} }));

          dispatch(
            setCoinList({
              result: data.result,
            })
          );
          dispatch(
            setNavigate({
              result: false,
            })
          );
        } else if (data.statusCode === 401) {
          handle401Status();
        }
        if (data.statusCode === 504) {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: "something went wrong.",
            })
          );
        }
      })
      .catch((err) => {
        return err.json();
        console.log(err);
      })
      .finally(() => {
        dispatch(toggleLoader({ isLoading: false }));
      });
  }
);

export const createCoin = createAsyncThunk(
  "create coin",
  async (payload: any, { dispatch }) => {
    dispatch(
      toggleLoader({
        isLoading: true,
      })
    );
    await fetch(endpoints.createCoin, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.statusCode === 200) {
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: data.errorMsg,
            })
          );
          dispatch(
            setNavigate({
              result: true,
            })
          );
        } else {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: "Something went wrong.",
            })
          );
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
        }
      })
      .catch((err) => {
        return err;
      });
  }
);

export const updateCoin = createAsyncThunk(
  "update coin",
  async (payload: any, { dispatch }) => {
    dispatch(
      toggleLoader({
        isLoading: true,
      })
    );
    console.log(payload);
    await fetch(endpoints.updateCoin, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.statusCode === 200) {
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: data.errorMsg,
            })
          );
          dispatch(
            setNavigate({
              result: true,
            })
          );
        } else {
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  }
);

export const deleteCoin = createAsyncThunk(
  "delete coin by id",
  async (payload: number, { dispatch }) => {
    dispatch(
      toggleLoader({
        isLoading: true,
      })
    );
    // console.log(payload)
    await fetch(`${endpoints.deleteCoin}${payload}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // console.log(data);
        if (data.statusCode === 200) {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: data.errorMsg,
            })
          );
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(getCoins());
        } else {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(getCoins());
        }
      });
  }
);

export const publishCoin = createAsyncThunk(
  "publish coin",
  async (payload: number, { dispatch }) => {
    dispatch(
      toggleLoader({
        isLoading: true,
      })
    );

    await fetch(`${endpoints.publishCoin}${payload}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // console.log(data)
        if (data.statusCode === 200) {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: data.errorMsg,
            })
          );
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(getCoins());
        } else {
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
        }
        if (data.statusCode === 500) {
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
        } else {
          dispatch(
            toggleLoader({
              isLoading: false,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  }
);

export const getCoinsById = createAsyncThunk(
  "get coins by id",
  async (payload: any, { dispatch }) => {
    // console.log(payload)
    dispatch(toggleLoader({ isLoading: true }));
    await fetch(`${endpoints.getCoinById}${payload}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        dispatch(toggleLoader({ isLoading: false }));

        return response.json();
      })
      .then((data) => {
        // console.log(data)
        if (data.statusCode === 200) {
          dispatch(
            setSingleCoin({
              result: data.result,
            })
          );
        }

        if (data.statusCode === 504) {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
);

export const getPurchaseCoinList = createAsyncThunk(
  "get publish coin list ",
  async (queryParams: string, { dispatch }) => {
    dispatch(toggleLoader({ isLoading: true }));
    await fetch(`${endpoints.purchasedCoinList}${queryParams}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        dispatch(toggleLoader({ isLoading: false }));
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.statusCode === 200) {
          dispatch(setSingleCoin({ result: {} }));

          dispatch(
            setCoinPurchaseList({
              result: data.result,
            })
          );
        } else if (data.statusCode === 504) {
          dispatch(
            setCoinPurchaseList({
              result: [],
            })
          );
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
        } else {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(toggleLoader({ isLoading: false }));
      });
  }
);

export const updateCoinDeliveryStatus = createAsyncThunk(
  "update coin delivery status",
  async (payload: any, { dispatch }) => {
    dispatch(toggleLoader({ isLoading: true }));
    await fetch(endpoints.coinDeliveryStatus, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${getLocalStorage(
          localStorageActiontype.GET_ACCESS_TOKEN
        )}`,
        "Content-type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        dispatch(toggleLoader({ isLoading: false }));
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.statusCode === 200) {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.success,
              message: data.errorMsg,
            })
          );
          dispatch(getPurchaseCoinList(payload.coinDeliveryStatus));
        } else {
          dispatch(
            toggleNotificationVisibility({
              isVisible: true,
              status: NotificationType.error,
              message: data.errorMsg,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(toggleLoader({ isLoading: false }));
      });
  }
);

const coinSlice = createSlice({
  name: "Coin Slice",
  initialState: coinInitialState,
  reducers: {
    setCoinList: (state, action: PayloadAction<SetCoinProps>) => {
      return {
        ...state,
        coins: action.payload.result,
      };
    },
    setCoinPurchaseList: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        purchaseList: action.payload.result,
      };
    },
    setSingleCoin: (state, action: PayloadAction<SetSingleCoinProps>) => {
      return {
        ...state,
        singleCoin: action.payload.result,
      };
    },
    setNavigate: (state, action: PayloadAction<SetNavProp>) => {
      return {
        ...state,
        isNavigate: action.payload.result,
      };
    },
  },
});

export const { setCoinList, setNavigate, setSingleCoin, setCoinPurchaseList } =
  coinSlice.actions;
export default coinSlice.reducer;
